import React, { } from 'react'
import './Footer.css'

class Footer extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
    }
  }

  componentDidMount () {

  }

  render () {
    return (
      <footer className='nav-footer' id='footer'>
        <section className='sitemap'>
          {/* eslint-disable  */}
          <a href='/' className='nav-home' />
          {/* eslint-enable  */}
          <div>
            <h5>Vendors</h5><a href='https://lushplans.com/vendors' target='_blank' rel='noreferrer noopener'>Top Vendors</a><a href='https://vendor.lushplans.com' target='_blank' rel='noreferrer noopener'>Vendor Profile</a><a href='https://lushplans.com/faq' target='_blank' rel='noreferrer noopener'>Vendor FAQ</a></div>
          <div>
            <h5>Couples</h5><a href='https://lushplans.com/app/#!/guests' target='_blank' rel='noreferrer noopener'>Manage guests</a><a href='https://lushplans.com/app/#!/invites' target='_blank' rel='noreferrer noopener'>Design Invitation</a><a href='https://lushplans.com/faq' target='_blank' rel='noreferrer noopener'>Couple FAQ</a></div>
          <div>
            <h5>Company</h5><a href='https://houseofbame.com/' target='_blank' rel='noreferrer noopener'>About us</a><a href='https://lushplans.com/careers'>Careers</a><a href='https://lushplans.com/terms/'>Terms</a></div>
          <div>
            <h5>Social Media</h5><a href='https://instagram.com/lushplans/' target='_blank' rel='noreferrer noopener'>Instagram</a><a href='https://twitter.com/lushplans/' target='_blank' rel='noreferrer noopener'>Twitter</a><a href='https://facebook.com/lushplans/' target='_blank' rel='noreferrer noopener'>Facebook</a></div>
        </section>
        <section className='copyright'>Copyright © 2018 Lush Plans</section>
      </footer>
    )
  }
};

export default Footer



// WEBPACK FOOTER //
// ./src/Footer/Footer.js